module.exports = __webpack_public_path__ + "img/53.2c3bf710.svg";